import React from "react";
import { Tooltip } from "primereact/tooltip";

interface MiniBarChartProps {
  values: number[];
  labels: string[];
  barColor?: string;
  maxHeight?: number;
  barWidth?: number;
  gap?: number;
}

export function MiniBarChart({
  values,
  labels = [],
  barColor = "var(--indigo-dataviz-1)",
  maxHeight = 70,
  barWidth = 25,
  gap = 6,
}: MiniBarChartProps) {
  const maxValue = Math.max(...values, 1);

  const chartSummary = `Bar chart of monthly lesson completions. ${labels.map((label, index) => `${label}: ${values[index]} lessons`).join(", ")}`;

  return (
    <div
      role="img"
      aria-label={chartSummary}
      style={{ display: "flex", alignItems: "flex-end", gap }}
    >
      {values.map((value, index) => {
        const height = value === 0 ? 2 : (value / maxValue) * maxHeight;
        const tooltipId = `mini-bar-${index}`;
        const label = labels[index];
        const tooltipText = label ? `${label} - ${value} lessons` : `${value} lessons`;

        return (
          <React.Fragment key={index}>
            <Tooltip target={`#${tooltipId}`} content={tooltipText} />
            <div
              id={tooltipId}
              aria-hidden="true"
              style={{
                width: barWidth,
                height,
                backgroundColor: barColor,
                borderRadius: 4,
                opacity: value === 0 ? 0.3 : 1,
              }}
            />
          </React.Fragment>
        );
      })}
    </div>
  );
}
